import withMetadataArgument from "./withMetadataArgument.js";
import formatIncompletePhoneNumber$1 from "../../es6/formatIncompletePhoneNumber.js";
function formatIncompletePhoneNumber() {
  return withMetadataArgument(formatIncompletePhoneNumber$1, arguments);
}
export {
  formatIncompletePhoneNumber
};
//# sourceMappingURL=formatIncompletePhoneNumber.js.map
